module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAVCAMAAACXIvXeAAAAYFBMVEUAAACBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYH0LnqlAAAAIHRSTlMACvGF6sZ5tko0JOXQcl8dGcqiE9m/UjytmY2MaSwVEOet0kUAAAC5SURBVBjTRY9ZEoQgDEQbhlUUcR1373/LSWBK30fSdBpSgBmMllJqM+BPo3ZPze+qKcbatSi03crNaEFVVLlqAyRFibtXtepvSqmEzweA3gTEpgE+1h6YJzDTDPgaUtCgKTspLiQkP06SbxgqMmfOcLFTXTljHefHeM6JXWcRLYtvP/UtCxuB0eHFjTwOw2MM4ZtXLI+zlKWiiyjEThRRqerthUPnpg88WEPFWLyk4OBCeg3+sqx9kT91dgaqamMOmgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_map.png
// module id = jdKn
// module chunks = 1